import React, { useContext } from "react";
import { FaHome } from "react-icons/fa";
import { FiSettings, FiClock, FiPlusCircle } from "react-icons/fi";
import styled from "styled-components";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { IoIosStats, IoIosShirt } from "react-icons/io";
import { GiSoccerField, GiSoccerBall } from "react-icons/gi";
import { GoCalendar, GoFile } from "react-icons/go";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";

const Main = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 0.5em;
  font-size: 1.5em;
  flex-direction: column;
  height: calc(100vh - var(--banner-offset, 0px));
`;

const BottomIcons = styled.div`
  display: flex;
  margin-top: auto;
  margin-bottom: 10px;
  align-items: center;
  flex-direction: column;
`;

const SettingsIcon = styled(FiSettings)`
  cursor: pointer;
`;

const LogIcon = styled(GoFile)`
  cursor: pointer;
`;
const Icon = styled.div`
  cursor: pointer;
  background-color: ${(props) => (props.selected === true ? "#db0a41" : "")};
  width: 100%;
  display: flex;
  justify-content: center;
  height: ${(props) => (props.home ? "92px" : "50px")};
  align-items: center;
  border-bottom: ${(props) => (props.home ? "1px solid #3d485d" : "")};
  box-shadow: ${(props) =>
    props.home ? "1px 5px 4px 1px rgb(0 0 0 / 25%)" : ""};
`;
export default function LeftSideBar({ view }) {
  const history = useHistory();
  const location = useLocation();
  let { gameID } = useParams();
  const { editUI, setEditUI, currentGame } = useContext(UIContext);
  return (
    <Main
      style={
        (view === VIEW_CONSTS.matchSelect && {
          height: "calc(100vh - 50px - var(--banner-offset, 0px))",
        }) ||
        {}
      }
    >
      {view !== VIEW_CONSTS.matchSelect && (
        <Icon
          home
          onClick={() => {
            history.push("/" + gameID);
          }}
        >
          <FaHome />
        </Icon>
      )}
      {view !== VIEW_CONSTS.matchSelect && (
        <Icon
          selected={view === VIEW_CONSTS.clockEdit}
          onClick={() => {
            history.push("/" + gameID + "/clock");
          }}
        >
          <FiClock />
        </Icon>
      )}
      {view !== VIEW_CONSTS.matchSelect &&
        currentGame?.dfb_ID !== null && (
        <Icon
          selected={view === VIEW_CONSTS.extras}
          onClick={() => {
            history.push("/" + gameID + "/extras");
          }}
        >
          <FiPlusCircle />
        </Icon>
      )}

      {(view === VIEW_CONSTS.formation || view === VIEW_CONSTS.stats) && (
        <Icon
          selected={view === VIEW_CONSTS.stats}
          //onClick={() => setView(VIEW_CONSTS.stats)}
        >
          <IoIosStats />
        </Icon>
      )}

      {gameID && (
        <Icon
          selected={view === VIEW_CONSTS.goals}
          onClick={() => {
            history.push("/" + gameID + "/kit");
          }}
        >
          <IoIosShirt />
        </Icon>
      )}
      <BottomIcons
        style={{ marginBottom: window.hideHeader ? "50px" : "20px" }}
      >
        {/* NOT READY YET
        <Icon
          onClick={() => {
            setEditUI(!editUI);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
            />
          </svg>
        </Icon> */}
        <Icon
          onClick={() => {
            if (location?.pathname?.indexOf("efl") > -1) {
              history.push({
                pathname: "/efl",
              });
            } else {
              history.push({
                pathname: "/",
              });
            }
          }}
        >
          <GoCalendar />
        </Icon>
      </BottomIcons>

      {/* <Icon
        selected={view === VIEW_CONSTS.all_graphics}
        onClick={() => setView(VIEW_CONSTS.all_graphics)}
      >
        <MdClearAll></MdClearAll>
      </Icon>
      <BottomIcons>
        <Icon
          onClick={() => {
            setSelectedGameID(null);
            history.push({
              pathname: mode === MODE_CONSTS.live ? "/" : "/MatchChoice",
            });
          }}
        >
          <GoCalendar />
        </Icon>
        <Icon>
          <LogIcon onClick={() => history.push({ pathname: "/Logs" })} />
        </Icon>
        <Icon>
          <SettingsIcon onClick={() => history.push({ pathname: "/Config" })} />
        </Icon> 
      </BottomIcons>*/}
    </Main>
  );
}
